import { TFunction } from 'i18next';

import { TValidator } from './types';

export const IN_RANGE_KEY = 'validation.inRange';

export const handleInRangeError = (errorMessage: string, t: TFunction, min: number, max: number) => {
  if (errorMessage === IN_RANGE_KEY) {
    return t(errorMessage, { max, min });
  }

  return t(errorMessage);
};

export const inRange =
  (min: number, max: number): TValidator =>
  (value: string | undefined | null) => {
    if (value === undefined || value === '' || value === null) {
      return undefined;
    }

    const parsedValue = Number.parseInt(value, 10);

    if (Number.isNaN(parsedValue) || parsedValue < min || parsedValue > max) {
      return IN_RANGE_KEY;
    }

    return undefined;
  };
